class Inventory {
  constructor({
    inventory
  }) {
    this.inventory = inventory;
  }
}

export default Inventory;